module.exports = __webpack_public_path__ + "img/shelltable.8c6cf180.png";